import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { environment } from 'src/environments/environment';
import { CommonFunctions } from '../common-functions';
@Injectable({
  providedIn: 'root'
})
export class MenuService {
  public server = environment.APIEndpoint;
  //::::::API EndPoints:Start::::::
  public urls: any = {
    getDummyMenuList: this.server + 'app/unsec/dummy/menu/get/v1',
    getSecMenuListItem: this.server + 'api/menu/v2/get?storeId=',
    getUnsecMenuListItem: this.server + 'app/unsec/menu/get/v1?storeId=',
    getMenuListItem2: this.server + 'app/menu/get/v1?storeId=',
    favMenuList: this.server + 'app/menu/favoriteProductsList/v1',
    saveFavouriteMenu: this.server + 'app/menu/add/favoriteProducts/v1',
    reorderItem: this.server + 'api/order/v1/reorder',
    reorderFavMenu: this.server + 'api/menu/favourite/reorder/v2/list?count=10',
    unSecTopMenuCat: this.server + 'api/unsec/menu/top/category/v1/list?count=3',
    secTopMenuCat: this.server + 'api/menu/top/category/v1/list?count=3'
  };
  //::::::API EndPoints:End::::::
  constructor(private http: HttpClient, private commonFunction: CommonFunctions, private apiHeader: ApiHeaderService) { }
  //::::::API Methods::Start:::::
  getDummyMenu(): Observable<any> {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.getDummyMenuList, { headers: secHeaders });
    } else {
     let unsecureHeaders =  this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.getDummyMenuList, { headers: unsecureHeaders });
       }
  }
  getMenuList(requestPayload): Observable<any> {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.getSecMenuListItem + requestPayload.storeId + requestPayload.channel, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.getUnsecMenuListItem + requestPayload.storeId + requestPayload.channel , { headers: unsecureHeaders });
    }
  }
  saveFavourite(requestPayload): Observable<any> {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.post(this.urls.saveFavouriteMenu, requestPayload, { headers: secHeaders });
    }
  }
  reorder(requestPayload): Observable<any> {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.reorderItem, requestPayload, { headers: secHeaders });
  }
  getFavMenuList(): Observable<any> {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.favMenuList, { headers: secHeaders });
    }
  }
  private favItemCache$: Observable<any>;
  getFavMenuItemCache() {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      if (!this.favItemCache$) {
        this.favItemCache$ = this.getFavMenuList().pipe(
          shareReplay(1),
        );
      }
      return this.favItemCache$;
    }
  }
  clearFavItemCache() {
    this.favItemCache$ = null;
  }
  reorderFavMenuList(): Observable<any> {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.reorderFavMenu, { headers: secHeaders });
    }
  }
  private secureReorderCache$: Observable<any>;
  reorderMenuCache() {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      if (!this.secureReorderCache$) {
        this.secureReorderCache$ = this.reorderFavMenuList().pipe(
          shareReplay(1),
        );
      }
      return this.secureReorderCache$;
    }
  }
  clearReorderMenuCache() {
    this.secureReorderCache$ = null
  }
  private dummyMenuList$: Observable<any>;
  getdummyMenuListcache() {
    if (!this.dummyMenuList$) {
      this.dummyMenuList$ = this.getDummyMenu().pipe(
        shareReplay(1),
      );
    }
    return this.dummyMenuList$;
  }
  private secureMenuCache$: Observable<any>;
  getMenuCache(req) {
    if (!this.secureMenuCache$) {
      this.secureMenuCache$ = this.getMenuList(req).pipe(
        shareReplay(1),
      );
    }
    return this.secureMenuCache$;
  }
  clearMenuList() {
    this.secureMenuCache$ = null;
  }
  clearDummyMenuListcache() {
    this.dummyMenuList$ = null;
  }
  topCategoryMenu() {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let secHeaders = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.secTopMenuCat, { headers: secHeaders });
    } else {
      let unsecureHeaders = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.unSecTopMenuCat, { headers: unsecureHeaders });
    }
  }
  private sendFilterData = new BehaviorSubject("");
  sendFilterTags(data: any) {
    this.sendFilterData.next(data);
  }
  getFilterTags(): Observable<any> {
    return this.sendFilterData.asObservable()
  }
  private closeSheetInfo = new Subject()
  sendCloseSheetInfo(data) {
    this.closeSheetInfo.next(data);
  }
  getcloseSheetInfo(): Observable<any> {
    return this.closeSheetInfo.asObservable()
  }
  private exploreMenu = new Subject();
  sendExploreMenu(data) {
    this.exploreMenu.next(data);
  }
  getExploreMenu(): Observable<any> {
    return this.exploreMenu.asObservable()
  }
  //::::::API Methods::End:::::
}
